module.exports = __webpack_public_path__ + "static/media/bg-item-mission.05fbf906.png";